/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * macweb API
 * OpenAPI spec version: 0.4.45
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CommunicationEventRow,
  CommunicationStateRow,
  CommunicationStats,
  CommunicationsEventsParams,
  CommunicationsStateParams,
  CommunicationsStatsParams,
  ErrorResponse,
  PollingLogCodeRef,
  PollingLogEntry,
  PollingLogParams
} from '.././model';

import { customInstance } from '../../orvalMutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get polling log entries
 */
export const pollingLog = (
    params?: PollingLogParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PollingLogEntry[]>(
      {url: `/api/communications/polling-log`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getPollingLogQueryKey = (params?: PollingLogParams,) => {
    return [
    `/api/communications/polling-log`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPollingLogQueryOptions = <TData = Awaited<ReturnType<typeof pollingLog>>, TError = ErrorResponse>(params?: PollingLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollingLog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPollingLogQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pollingLog>>> = ({ signal }) => pollingLog(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pollingLog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PollingLogQueryResult = NonNullable<Awaited<ReturnType<typeof pollingLog>>>
export type PollingLogQueryError = ErrorResponse


export function usePollingLog<TData = Awaited<ReturnType<typeof pollingLog>>, TError = ErrorResponse>(
 params: undefined |  PollingLogParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollingLog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pollingLog>>,
          TError,
          Awaited<ReturnType<typeof pollingLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollingLog<TData = Awaited<ReturnType<typeof pollingLog>>, TError = ErrorResponse>(
 params?: PollingLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollingLog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pollingLog>>,
          TError,
          Awaited<ReturnType<typeof pollingLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollingLog<TData = Awaited<ReturnType<typeof pollingLog>>, TError = ErrorResponse>(
 params?: PollingLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollingLog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get polling log entries
 */

export function usePollingLog<TData = Awaited<ReturnType<typeof pollingLog>>, TError = ErrorResponse>(
 params?: PollingLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollingLog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPollingLogQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get polling log event codes reference
 */
export const pollingLogCodes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PollingLogCodeRef[]>(
      {url: `/api/communications/polling-log/codes`, method: 'GET', signal
    },
      options);
    }
  



export const getPollingLogCodesQueryKey = () => {
    return [
    `/api/communications/polling-log/codes`
    ] as const;
    }

    
export const getPollingLogCodesQueryOptions = <TData = Awaited<ReturnType<typeof pollingLogCodes>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollingLogCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPollingLogCodesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pollingLogCodes>>> = ({ signal }) => pollingLogCodes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pollingLogCodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PollingLogCodesQueryResult = NonNullable<Awaited<ReturnType<typeof pollingLogCodes>>>
export type PollingLogCodesQueryError = ErrorResponse


export function usePollingLogCodes<TData = Awaited<ReturnType<typeof pollingLogCodes>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollingLogCodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pollingLogCodes>>,
          TError,
          Awaited<ReturnType<typeof pollingLogCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollingLogCodes<TData = Awaited<ReturnType<typeof pollingLogCodes>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollingLogCodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pollingLogCodes>>,
          TError,
          Awaited<ReturnType<typeof pollingLogCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePollingLogCodes<TData = Awaited<ReturnType<typeof pollingLogCodes>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollingLogCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get polling log event codes reference
 */

export function usePollingLogCodes<TData = Awaited<ReturnType<typeof pollingLogCodes>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pollingLogCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPollingLogCodesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get communication state for meters
 */
export const communicationsState = (
    params?: CommunicationsStateParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CommunicationStateRow[]>(
      {url: `/api/communications/state`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getCommunicationsStateQueryKey = (params?: CommunicationsStateParams,) => {
    return [
    `/api/communications/state`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCommunicationsStateQueryOptions = <TData = Awaited<ReturnType<typeof communicationsState>>, TError = ErrorResponse>(params?: CommunicationsStateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationsState>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommunicationsStateQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof communicationsState>>> = ({ signal }) => communicationsState(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof communicationsState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CommunicationsStateQueryResult = NonNullable<Awaited<ReturnType<typeof communicationsState>>>
export type CommunicationsStateQueryError = ErrorResponse


export function useCommunicationsState<TData = Awaited<ReturnType<typeof communicationsState>>, TError = ErrorResponse>(
 params: undefined |  CommunicationsStateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationsState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof communicationsState>>,
          TError,
          Awaited<ReturnType<typeof communicationsState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommunicationsState<TData = Awaited<ReturnType<typeof communicationsState>>, TError = ErrorResponse>(
 params?: CommunicationsStateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationsState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof communicationsState>>,
          TError,
          Awaited<ReturnType<typeof communicationsState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommunicationsState<TData = Awaited<ReturnType<typeof communicationsState>>, TError = ErrorResponse>(
 params?: CommunicationsStateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationsState>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get communication state for meters
 */

export function useCommunicationsState<TData = Awaited<ReturnType<typeof communicationsState>>, TError = ErrorResponse>(
 params?: CommunicationsStateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationsState>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommunicationsStateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get communication events
 */
export const communicationsEvents = (
    params?: CommunicationsEventsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CommunicationEventRow[]>(
      {url: `/api/communications/events`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getCommunicationsEventsQueryKey = (params?: CommunicationsEventsParams,) => {
    return [
    `/api/communications/events`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCommunicationsEventsQueryOptions = <TData = Awaited<ReturnType<typeof communicationsEvents>>, TError = ErrorResponse>(params?: CommunicationsEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationsEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommunicationsEventsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof communicationsEvents>>> = ({ signal }) => communicationsEvents(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof communicationsEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CommunicationsEventsQueryResult = NonNullable<Awaited<ReturnType<typeof communicationsEvents>>>
export type CommunicationsEventsQueryError = ErrorResponse


export function useCommunicationsEvents<TData = Awaited<ReturnType<typeof communicationsEvents>>, TError = ErrorResponse>(
 params: undefined |  CommunicationsEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationsEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof communicationsEvents>>,
          TError,
          Awaited<ReturnType<typeof communicationsEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommunicationsEvents<TData = Awaited<ReturnType<typeof communicationsEvents>>, TError = ErrorResponse>(
 params?: CommunicationsEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationsEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof communicationsEvents>>,
          TError,
          Awaited<ReturnType<typeof communicationsEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommunicationsEvents<TData = Awaited<ReturnType<typeof communicationsEvents>>, TError = ErrorResponse>(
 params?: CommunicationsEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationsEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get communication events
 */

export function useCommunicationsEvents<TData = Awaited<ReturnType<typeof communicationsEvents>>, TError = ErrorResponse>(
 params?: CommunicationsEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationsEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommunicationsEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get aggregated communication statistics
 */
export const communicationsStats = (
    params?: CommunicationsStatsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CommunicationStats>(
      {url: `/api/communications/stats`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getCommunicationsStatsQueryKey = (params?: CommunicationsStatsParams,) => {
    return [
    `/api/communications/stats`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCommunicationsStatsQueryOptions = <TData = Awaited<ReturnType<typeof communicationsStats>>, TError = ErrorResponse>(params?: CommunicationsStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationsStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommunicationsStatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof communicationsStats>>> = ({ signal }) => communicationsStats(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof communicationsStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CommunicationsStatsQueryResult = NonNullable<Awaited<ReturnType<typeof communicationsStats>>>
export type CommunicationsStatsQueryError = ErrorResponse


export function useCommunicationsStats<TData = Awaited<ReturnType<typeof communicationsStats>>, TError = ErrorResponse>(
 params: undefined |  CommunicationsStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationsStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof communicationsStats>>,
          TError,
          Awaited<ReturnType<typeof communicationsStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommunicationsStats<TData = Awaited<ReturnType<typeof communicationsStats>>, TError = ErrorResponse>(
 params?: CommunicationsStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationsStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof communicationsStats>>,
          TError,
          Awaited<ReturnType<typeof communicationsStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommunicationsStats<TData = Awaited<ReturnType<typeof communicationsStats>>, TError = ErrorResponse>(
 params?: CommunicationsStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationsStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get aggregated communication statistics
 */

export function useCommunicationsStats<TData = Awaited<ReturnType<typeof communicationsStats>>, TError = ErrorResponse>(
 params?: CommunicationsStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communicationsStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommunicationsStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




